<template>
  <NamiModal v-model="isOpen" large darker>
    <NamiModalTitle @close="isOpen = false"> Add a highlight </NamiModalTitle>

    <div v-if="bookmark" class="space-y-4">
      <div class="space-y-2">
        <div
          class="p-4 rounded-md border border-neutral-200 dark:border-neutral-800 space-y-2"
        >
          <NovelBookmarkCard :bookmark no-options no-name />
          <NamiTextArea v-model="comment" placeholder="Set a note (optional)" />
        </div>
      </div>

      <div class="flex justify-between">
        <NamiButton button-type="primary" @button-click="save">
          Save
        </NamiButton>
        <NamiButton button-type="secondary" @button-click="abandon">
          Cancel
        </NamiButton>
      </div>
    </div>
  </NamiModal>
</template>

<script setup lang="ts">
import type { NovelBookmarkEntity } from "~/src/api";

const emit = defineEmits<{
  (e: "save", bookmark: NovelBookmarkEntity): void;
}>();

const isOpen = ref(false);
const comment = ref("");
const bookmark = ref<NovelBookmarkEntity>();

function save() {
  if (!bookmark.value) return;
  bookmark.value.attributes.comment = comment.value;
  emit("save", bookmark.value);
  resetLater();
  isOpen.value = false;
}

function abandon() {
  resetLater();
  isOpen.value = false;
}

function resetLater() {
  setTimeout(() => {
    comment.value = "";
  }, 300);
}

watch(bookmark, (newBookmark) => {
  comment.value = newBookmark?.attributes.comment ?? "";
});

defineExpose({
  open: (bookmarkEntity: NovelBookmarkEntity) => {
    isOpen.value = true;
    bookmark.value = bookmarkEntity;
  },
});
</script>
